var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDesktopDivider1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1366,
    height: 26,
    viewBox: "0 0 1366 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #586f93;\r\n      }\r\n\r\n      .cls-2 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n\r\n      .cls-3 {\r\n        opacity: 0.07;\r\n        mix-blend-mode: lighten;\r\n        isolation: isolate;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #f1e3cf;\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: #d33367;\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: #36868e;\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: #2d374c;\r\n      }\r\n\r\n      .cls-8 {\r\n        fill: #ff8b61;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    className: "cls-1",
    width: 1366,
    height: 26,
    transform: "translate(0 755)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web_Divider_1",
    "data-name": "Web Divider 1",
    transform: "translate(0 -755)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_629",
    "data-name": "Rectangle 629",
    className: "cls-1",
    width: 1366,
    height: 26,
    transform: "translate(0 755)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_3",
    "data-name": "Mask Group 3",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55",
    "data-name": "Group 55",
    className: "cls-3",
    transform: "translate(218.98 -781)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52",
    transform: "translate(-3208.011 -11)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Shape",
    className: "cls-4",
    cx: 10.924,
    cy: 10.919,
    rx: 10.924,
    ry: 10.919,
    transform: "translate(4060.248 1549.049)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    className: "cls-5",
    d: "M133.789,0a12.92,12.92,0,0,1-12.9,12.936A12.92,12.92,0,0,1,133.789,0Z",
    transform: "translate(3950.351 1547)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    className: "cls-6",
    d: "M12.559,0h.377V.376A12.544,12.544,0,0,1,.377,12.9H0v-.376A12.544,12.544,0,0,1,12.559,0Z",
    transform: "translate(4071.044 1547) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    "data-name": "Shape",
    className: "cls-5",
    d: "M12.528,120.591H12.9v.377A12.544,12.544,0,0,1,.376,133.527H0v-.377A12.544,12.544,0,0,1,12.528,120.591Z",
    transform: "translate(4058.14 1439.473)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-5",
    "data-name": "Shape",
    className: "cls-6",
    d: "M12.559,0h.377V.376A12.544,12.544,0,0,1,.377,12.9H0v-.376A12.544,12.544,0,0,1,12.559,0Z",
    transform: "translate(4084.14 1560.064) rotate(90)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Shape-6",
    "data-name": "Shape",
    className: "cls-4",
    cx: 10.924,
    cy: 10.924,
    r: 10.924,
    transform: "translate(4138.22 1549.015)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-7",
    "data-name": "Shape",
    className: "cls-5",
    d: "M12.621,133A12.621,12.621,0,0,1,0,120.379V120H.379A12.621,12.621,0,0,1,13,132.621V133Z",
    transform: "translate(4136.14 1440)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-8",
    "data-name": "Shape",
    className: "cls-6",
    d: "M132.621,120H133v.379A12.621,12.621,0,0,1,120.379,133H120v-.379A12.621,12.621,0,0,1,132.621,120Z",
    transform: "translate(4029.14 1440)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-9",
    "data-name": "Shape",
    className: "cls-5",
    d: "M120.379,13H120v-.379A12.621,12.621,0,0,1,132.621,0H133V.379A12.621,12.621,0,0,1,120.379,13Z",
    transform: "translate(4029.14 1547)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-10",
    "data-name": "Shape",
    className: "cls-6",
    d: "M.379,0A12.621,12.621,0,0,1,13,12.621V13h-.379A12.621,12.621,0,0,1,0,.379V0Z",
    transform: "translate(4136.14 1547)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-11",
    "data-name": "Shape",
    className: "cls-5",
    d: "M26,0V26H0A26,26,0,0,1,26,0Z",
    transform: "translate(4214.14 1547) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-12",
    "data-name": "Shape",
    className: "cls-4",
    d: "M14.793,0V14.757H0A14.775,14.775,0,0,1,14.793,0Z",
    transform: "translate(4202.896 1558.207) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-13",
    "data-name": "Shape",
    className: "cls-7",
    d: "M6.788,0V6.771H0A6.78,6.78,0,0,1,6.788,0Z",
    transform: "translate(4194.911 1566.212) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-14",
    "data-name": "Shape",
    className: "cls-6",
    d: "M26,0V26H0A26,26,0,0,1,26,0Z",
    transform: "translate(4058.14 1573) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-15",
    "data-name": "Shape",
    className: "cls-4",
    d: "M14.757,0V14.793H0A14.775,14.775,0,0,1,14.757,0Z",
    transform: "translate(4046.897 1561.793) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-16",
    "data-name": "Shape",
    className: "cls-7",
    d: "M6.771,0V6.788H0A6.78,6.78,0,0,1,6.771,0Z",
    transform: "translate(4038.912 1553.788) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-17",
    "data-name": "Shape",
    className: "cls-6",
    d: "M26,0V26H0A26,26,0,0,1,26,0Z",
    transform: "translate(4162.14 1547)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-18",
    "data-name": "Shape",
    className: "cls-4",
    d: "M118.541,103.448v14.793H103.784A14.775,14.775,0,0,1,118.541,103.448Z",
    transform: "translate(4069.599 1454.759)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-19",
    "data-name": "Shape",
    className: "cls-7",
    d: "M184.265,177.34v6.788h-6.771A6.78,6.78,0,0,1,184.265,177.34Z",
    transform: "translate(4003.874 1388.872)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shape-20",
    "data-name": "Shape",
    transform: "translate(4106.522 1569.242) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    className: "cls-7",
    d: "M0,0,13.047,0l0,13.047L0,13.047Z",
    transform: "translate(9.229 0) rotate(45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    className: "cls-6",
    d: "M0,0H6.567V6.572H0Z",
    transform: "translate(5.945 5.943)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape-21",
    "data-name": "Shape",
    transform: "translate(4136.14 1573) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    className: "cls-4",
    d: "M13,0a13,13,0,0,1,0,26H0V13A13,13,0,0,1,13,0Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    className: "cls-5",
    d: "M7.774,0a7.774,7.774,0,1,1,0,15.548H0V7.774A7.774,7.774,0,0,1,7.774,0Z",
    transform: "translate(0 10.452)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    className: "cls-6",
    d: "M7.937,0A7.937,7.937,0,1,1,0,7.937,7.937,7.937,0,0,1,7.937,0Z",
    transform: "translate(5.063 4.932)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    className: "cls-7",
    d: "M4.646,0A4.646,4.646,0,1,1,0,4.646,4.646,4.646,0,0,1,4.646,0Z",
    transform: "translate(8.354 8.223)"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Shape-22",
    "data-name": "Shape",
    className: "cls-5",
    cx: 13,
    cy: 13,
    r: 13,
    transform: "translate(3876.205 1547)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Shape-23",
    "data-name": "Shape",
    className: "cls-7",
    cx: 7.632,
    cy: 7.632,
    r: 7.632,
    transform: "translate(3881.638 1552.433)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Shape-24",
    "data-name": "Shape",
    className: "cls-6",
    cx: 4.01,
    cy: 4.01,
    r: 4.01,
    transform: "translate(3885.26 1556.055)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Shape-25",
    "data-name": "Shape",
    className: "cls-8",
    cx: 13,
    cy: 13,
    r: 13,
    transform: "translate(3928.14 1547)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Shape-26",
    "data-name": "Shape",
    className: "cls-7",
    cx: 7.632,
    cy: 7.632,
    r: 7.632,
    transform: "translate(3933.573 1552.433)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Shape-27",
    "data-name": "Shape",
    className: "cls-4",
    cx: 4.01,
    cy: 4.01,
    r: 4.01,
    transform: "translate(3937.195 1556.055)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-28",
    "data-name": "Shape",
    className: "cls-5",
    d: "M6.388,12.776A6.388,6.388,0,1,0,0,6.388,6.388,6.388,0,0,0,6.388,12.776Z",
    transform: "translate(3980.108 1560.192) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-29",
    "data-name": "Shape",
    className: "cls-8",
    d: "M6.388,12.776A6.388,6.388,0,1,0,0,6.388,6.388,6.388,0,0,0,6.388,12.776Z",
    transform: "translate(3966.948 1560.192) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-30",
    "data-name": "Shape",
    className: "cls-8",
    d: "M6.388,12.776A6.388,6.388,0,1,0,0,6.388,6.388,6.388,0,0,0,6.388,12.776Z",
    transform: "translate(3980.108 1547.287) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-31",
    "data-name": "Shape",
    className: "cls-6",
    d: "M0,13.1H6.516A6.548,6.548,0,1,0,0,6.548Z",
    transform: "translate(3967.236 1547) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Shape-32",
    "data-name": "Shape",
    className: "cls-4",
    width: 13.287,
    height: 13.287,
    transform: "translate(3999.816 1566.676) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-33",
    "data-name": "Shape",
    className: "cls-6",
    d: "M0,8.1H8.1V0H0Z",
    transform: "translate(3998.803 1560.065) rotate(135)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-34",
    "data-name": "Shape",
    className: "cls-5",
    d: "M0,7.857H7.857A7.857,7.857,0,0,0,0,0Z",
    transform: "translate(4003.649 1557.349) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-35",
    "data-name": "Shape",
    className: "cls-5",
    d: "M0,0V7.857A7.857,7.857,0,0,0,7.857,0Z",
    transform: "translate(4003.649 1570.509) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-36",
    "data-name": "Shape",
    className: "cls-5",
    d: "M7.857,0H0A7.857,7.857,0,0,0,7.857,7.857Z",
    transform: "translate(3990.681 1570.509) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-37",
    "data-name": "Shape",
    className: "cls-5",
    d: "M7.857,7.857V0A7.857,7.857,0,0,0,0,7.857Z",
    transform: "translate(3990.681 1557.349) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shape-38",
    "data-name": "Shape",
    transform: "translate(3872.458 1569.243) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    className: "cls-8",
    d: "M0,0,13.047,0l0,13.047L0,13.047Z",
    transform: "translate(9.229 0) rotate(45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    className: "cls-4",
    d: "M0,0,6.569,0l0,6.569L0,6.569Z",
    transform: "translate(9.229 4.582) rotate(45)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Shape-39",
    "data-name": "Shape",
    className: "cls-4",
    cx: 10.924,
    cy: 10.919,
    rx: 10.924,
    ry: 10.919,
    transform: "translate(4008.248 1549.049)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-40",
    "data-name": "Shape",
    className: "cls-5",
    d: "M133.789,0a12.92,12.92,0,0,1-12.9,12.936A12.92,12.92,0,0,1,133.789,0Z",
    transform: "translate(3898.351 1547)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-41",
    "data-name": "Shape",
    className: "cls-6",
    d: "M12.559,0h.377V.376A12.544,12.544,0,0,1,.377,12.9H0v-.376A12.544,12.544,0,0,1,12.559,0Z",
    transform: "translate(4019.044 1547) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-42",
    "data-name": "Shape",
    className: "cls-5",
    d: "M12.528,120.591H12.9v.377A12.544,12.544,0,0,1,.376,133.527H0v-.377A12.544,12.544,0,0,1,12.528,120.591Z",
    transform: "translate(4006.14 1439.473)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-43",
    "data-name": "Shape",
    className: "cls-6",
    d: "M12.559,0h.377V.376A12.544,12.544,0,0,1,.377,12.9H0v-.376A12.544,12.544,0,0,1,12.559,0Z",
    transform: "translate(4032.14 1560.064) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-44",
    "data-name": "Shape",
    className: "cls-8",
    d: "M59.4,0H72.53L65.965,6.565Z",
    transform: "translate(3849.175 1547)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-45",
    "data-name": "Shape",
    className: "cls-6",
    d: "M26,0V26H0Z",
    transform: "translate(3902.14 1547)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-46",
    "data-name": "Shape",
    className: "cls-4",
    d: "M0,0,26,26H0Z",
    transform: "translate(3902.14 1547)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Shape-47",
    "data-name": "Shape",
    className: "cls-8",
    cx: 13,
    cy: 13,
    r: 13,
    transform: "translate(4344.14 1547)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Shape-48",
    "data-name": "Shape",
    className: "cls-7",
    cx: 7.632,
    cy: 7.632,
    r: 7.632,
    transform: "translate(4349.573 1552.303)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Shape-49",
    "data-name": "Shape",
    className: "cls-4",
    cx: 4.01,
    cy: 4.01,
    r: 4.01,
    transform: "translate(4353.195 1555.925)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shape-50",
    "data-name": "Shape",
    transform: "translate(4396.14 1573) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    className: "cls-4",
    d: "M13,26A13,13,0,0,0,13,0H0V13A13,13,0,0,0,13,26Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    className: "cls-5",
    d: "M7.774,15.548A7.774,7.774,0,1,0,7.774,0H0V7.774A7.774,7.774,0,0,0,7.774,15.548Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    className: "cls-6",
    d: "M7.937,15.874A7.937,7.937,0,1,0,0,7.937,7.937,7.937,0,0,0,7.937,15.874Z",
    transform: "translate(5.063 5.194)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    className: "cls-7",
    d: "M4.646,9.293A4.646,4.646,0,1,0,0,4.646,4.646,4.646,0,0,0,4.646,9.293Z",
    transform: "translate(8.354 8.484)"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Shape-51",
    "data-name": "Shape",
    className: "cls-4",
    cx: 10.924,
    cy: 10.924,
    r: 10.924,
    transform: "translate(4238.125 1549.08) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-52",
    "data-name": "Shape",
    className: "cls-5",
    d: "M12.621,13A12.621,12.621,0,0,1,0,.379V0H.379A12.621,12.621,0,0,1,13,12.621V13Z",
    transform: "translate(4227.14 1547) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-53",
    "data-name": "Shape",
    className: "cls-6",
    d: "M12.621,0H13V.379A12.621,12.621,0,0,1,.379,13H0v-.379A12.621,12.621,0,0,1,12.621,0Z",
    transform: "translate(4227.14 1560) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-54",
    "data-name": "Shape",
    className: "cls-5",
    d: "M.379,13H0v-.379A12.621,12.621,0,0,1,12.621,0H13V.379A12.621,12.621,0,0,1,.379,13Z",
    transform: "translate(4240.14 1560) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-55",
    "data-name": "Shape",
    className: "cls-6",
    d: "M.379,0A12.621,12.621,0,0,1,13,12.621V13h-.379A12.621,12.621,0,0,1,0,.379V0Z",
    transform: "translate(4240.14 1547) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-56",
    "data-name": "Shape",
    className: "cls-5",
    d: "M6.388,0A6.388,6.388,0,1,1,0,6.388,6.388,6.388,0,0,1,6.388,0Z",
    transform: "translate(4279.332 1559.808) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-57",
    "data-name": "Shape",
    className: "cls-8",
    d: "M6.388,0A6.388,6.388,0,1,1,0,6.388,6.388,6.388,0,0,1,6.388,0Z",
    transform: "translate(4266.172 1559.808) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-58",
    "data-name": "Shape",
    className: "cls-8",
    d: "M6.388,0A6.388,6.388,0,1,1,0,6.388,6.388,6.388,0,0,1,6.388,0Z",
    transform: "translate(4279.332 1572.713) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-59",
    "data-name": "Shape",
    className: "cls-6",
    d: "M0,0H6.516A6.548,6.548,0,1,1,0,6.548Z",
    transform: "translate(4266.14 1573) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Shape-60",
    "data-name": "Shape",
    className: "cls-4",
    width: 13.288,
    height: 13.288,
    transform: "translate(4311.815 1566.612) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-61",
    "data-name": "Shape",
    className: "cls-6",
    d: "M0,0H8.1V8.1H0Z",
    transform: "translate(4305.075 1565.662) rotate(-135)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-62",
    "data-name": "Shape",
    className: "cls-5",
    d: "M0,0H7.857A7.858,7.858,0,0,1,0,7.857Z",
    transform: "translate(4315.648 1570.509) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-63",
    "data-name": "Shape",
    className: "cls-5",
    d: "M0,7.857V0A7.857,7.857,0,0,1,7.857,7.857Z",
    transform: "translate(4315.648 1557.349) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-64",
    "data-name": "Shape",
    className: "cls-5",
    d: "M7.857,7.857H0A7.857,7.857,0,0,1,7.857,0Z",
    transform: "translate(4302.68 1557.349) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-65",
    "data-name": "Shape",
    className: "cls-5",
    d: "M7.857,0V7.857A7.857,7.857,0,0,1,0,0Z",
    transform: "translate(4302.68 1570.509) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shape-66",
    "data-name": "Shape",
    transform: "translate(4240.14 1547)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    className: "cls-6",
    d: "M13,0H26V13A13,13,0,0,1,13,26H0V13A13,13,0,0,1,13,0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    className: "cls-7",
    d: "M57.09,51.859a7.643,7.643,0,1,1,0,15.286H49.447V59.5A7.643,7.643,0,0,1,57.09,51.859Z",
    transform: "translate(-44.09 -46.241)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    className: "cls-4",
    d: "M128.4,0h5.2V5.2a7.8,7.8,0,0,1-7.8,7.8h-5.2V7.8A7.8,7.8,0,0,1,128.4,0Z",
    transform: "translate(-107.538)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Shape-67",
    "data-name": "Shape",
    className: "cls-8",
    d: "M0,0H13.13L6.565,6.565Z",
    transform: "translate(4337.77 1573) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-68",
    "data-name": "Shape",
    className: "cls-6",
    d: "M26,0V26H0Z",
    transform: "translate(4344.205 1573) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-69",
    "data-name": "Shape",
    className: "cls-4",
    d: "M0,0,26,26H0Z",
    transform: "translate(4344.205 1573) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shape-70",
    "data-name": "Shape",
    transform: "translate(4574.011 1569.225) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    className: "cls-7",
    d: "M0,13.019l13.014,0L13.019,0,0,0Z",
    transform: "translate(0 9.206) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    className: "cls-6",
    d: "M0,6.555H6.551V0H0Z",
    transform: "translate(5.93 5.928)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Shape-71",
    "data-name": "Shape",
    className: "cls-6",
    d: "M12.967,0A12.967,12.967,0,1,1,0,12.967,12.967,12.967,0,0,1,12.967,0Z",
    transform: "translate(4525.814 1547.065)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-72",
    "data-name": "Shape",
    className: "cls-4",
    d: "M56.16,48.354a7.806,7.806,0,1,1-7.806,7.806A7.806,7.806,0,0,1,56.16,48.354Z",
    transform: "translate(4482.686 1503.937)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-73",
    "data-name": "Shape",
    className: "cls-7",
    d: "M87.319,83.145a4.174,4.174,0,1,1-4.174,4.174A4.174,4.174,0,0,1,87.319,83.145Z",
    transform: "translate(4451.654 1472.905)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-74",
    "data-name": "Shape",
    className: "cls-5",
    d: "M110.088,94.349v15.739H94.349A15.739,15.739,0,0,1,110.088,94.349Z",
    transform: "translate(4441.661 1462.912)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-75",
    "data-name": "Shape",
    className: "cls-5",
    d: "M6.372,0A6.372,6.372,0,1,1,0,6.372,6.372,6.372,0,0,1,6.372,0Z",
    transform: "translate(4408.885 1559.81) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-76",
    "data-name": "Shape",
    className: "cls-8",
    d: "M6.372,0A6.372,6.372,0,1,1,0,6.372,6.372,6.372,0,0,1,6.372,0Z",
    transform: "translate(4408.885 1573) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-77",
    "data-name": "Shape",
    className: "cls-8",
    d: "M6.372,0A6.372,6.372,0,1,1,0,6.372,6.372,6.372,0,0,1,6.372,0Z",
    transform: "translate(4421.82 1559.81) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-78",
    "data-name": "Shape",
    className: "cls-6",
    d: "M0,0H6.532A6.532,6.532,0,1,1,0,6.532Z",
    transform: "translate(4422.075 1573) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shape-79",
    "data-name": "Shape",
    transform: "translate(4448.01 1547.065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    className: "cls-4",
    d: "M12.967,0a12.967,12.967,0,1,1,0,25.935H0V12.967A12.967,12.967,0,0,1,12.967,0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    className: "cls-7",
    d: "M7.754,96.482a7.754,7.754,0,1,1,0,15.509H0v-7.754A7.754,7.754,0,0,1,7.754,96.482Z",
    transform: "translate(0 -86.056)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    className: "cls-6",
    d: "M54.651,45.528a7.917,7.917,0,1,1-7.917,7.917A7.917,7.917,0,0,1,54.651,45.528Z",
    transform: "translate(-41.684 -40.608)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    className: "cls-7",
    d: "M81.745,75.9a4.635,4.635,0,1,1-4.635,4.635A4.635,4.635,0,0,1,81.745,75.9Z",
    transform: "translate(-68.778 -67.702)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape-80",
    "data-name": "Shape",
    transform: "translate(4473.944 1573) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    className: "cls-6",
    d: "M13.033,0h12.9V12.9A13.033,13.033,0,0,1,12.9,25.935H0v-12.9A13.033,13.033,0,0,1,13.033,0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    className: "cls-7",
    d: "M7.624,0a7.624,7.624,0,1,1,0,15.248H0V7.624A7.624,7.624,0,0,1,7.624,0Z",
    transform: "translate(5.343 5.604)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    className: "cls-8",
    d: "M7.78,0h5.187V5.187a7.78,7.78,0,0,1-7.78,7.78H0V7.78A7.78,7.78,0,0,1,7.78,0Z",
    transform: "translate(13.033)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Shape-81",
    "data-name": "Shape",
    className: "cls-6",
    d: "M72.5,185.949H59.4l6.549-6.549Z",
    transform: "translate(4369.094 1387.052)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-82",
    "data-name": "Shape",
    className: "cls-4",
    d: "M0,25.935V0H25.935Z",
    transform: "translate(4422.075 1547.065)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-83",
    "data-name": "Shape",
    className: "cls-5",
    d: "M25.935,25.935,0,0H25.935Z",
    transform: "translate(4422.075 1547.065)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-84",
    "data-name": "Shape",
    className: "cls-8",
    d: "M59.4,0H72.5L65.949,6.549Z",
    transform: "translate(4446.963 1547.065)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-85",
    "data-name": "Shape",
    className: "cls-6",
    d: "M25.935,0V25.935H0Z",
    transform: "translate(4499.944 1547.065)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-86",
    "data-name": "Shape",
    className: "cls-4",
    d: "M0,0,25.935,25.935H0Z",
    transform: "translate(4499.944 1547.065)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shape-87",
    "data-name": "Shape",
    transform: "translate(3776.195 1547)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    className: "cls-4",
    d: "M12.967-214.065a12.967,12.967,0,0,0,12.967-12.967A12.967,12.967,0,0,0,12.967-240H0v12.967A12.967,12.967,0,0,0,12.967-214.065Z",
    transform: "translate(0 240)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    className: "cls-7",
    d: "M7.754-224.491a7.754,7.754,0,0,0,7.754-7.754A7.754,7.754,0,0,0,7.754-240H0v7.754A7.754,7.754,0,0,0,7.754-224.491Z",
    transform: "translate(0 240)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    className: "cls-6",
    d: "M54.651-176.225a7.917,7.917,0,0,0,7.917-7.917,7.917,7.917,0,0,0-7.917-7.917,7.917,7.917,0,0,0-7.917,7.917A7.917,7.917,0,0,0,54.651-176.225Z",
    transform: "translate(-41.684 197.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    className: "cls-7",
    d: "M81.745-152.414a4.635,4.635,0,0,0,4.635-4.635,4.635,4.635,0,0,0-4.635-4.635,4.635,4.635,0,0,0-4.635,4.635A4.635,4.635,0,0,0,81.745-152.414Z",
    transform: "translate(-68.778 170.146)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape-88",
    "data-name": "Shape",
    transform: "translate(3828.065 1547) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    className: "cls-6",
    d: "M13.033,25.935h12.9v-12.9A13.033,13.033,0,0,0,12.9,0H0V12.9A13.033,13.033,0,0,0,13.033,25.935Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    className: "cls-7",
    d: "M7.624,15.248A7.624,7.624,0,1,0,7.624,0H0V7.624A7.624,7.624,0,0,0,7.624,15.248Z",
    transform: "translate(5.343 5.083)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    className: "cls-8",
    d: "M7.78,12.967h5.187V7.78A7.78,7.78,0,0,0,5.187,0H0V5.187A7.78,7.78,0,0,0,7.78,12.967Z",
    transform: "translate(13.033 12.967)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape-89",
    "data-name": "Shape",
    transform: "translate(3854 1547) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    className: "cls-5",
    d: "M13.033,0h12.9V12.9A13.033,13.033,0,0,1,12.9,25.935H0v-12.9A13.033,13.033,0,0,1,13.033,0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    className: "cls-7",
    d: "M7.624,0a7.624,7.624,0,1,1,0,15.248H0V7.624A7.624,7.624,0,0,1,7.624,0Z",
    transform: "translate(5.343 5.604)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    className: "cls-8",
    d: "M7.78,0h5.187V5.187a7.78,7.78,0,0,1-7.78,7.78H0V7.78A7.78,7.78,0,0,1,7.78,0Z",
    transform: "translate(13.033)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Shape-90",
    "data-name": "Shape",
    className: "cls-5",
    d: "M25.935,0V25.935H0A25.935,25.935,0,0,1,25.935,0Z",
    transform: "translate(3724.326 1547)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-91",
    "data-name": "Shape",
    className: "cls-4",
    d: "M118.2,103.784V118.5H103.448A14.738,14.738,0,0,1,118.2,103.784Z",
    transform: "translate(3632.056 1454.431)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-92",
    "data-name": "Shape",
    className: "cls-7",
    d: "M184.111,177.494v6.755H177.34A6.763,6.763,0,0,1,184.111,177.494Z",
    transform: "translate(3566.149 1388.686)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-93",
    "data-name": "Shape",
    className: "cls-6",
    d: "M12.967,0A12.967,12.967,0,1,1,0,12.967,12.967,12.967,0,0,1,12.967,0Z",
    transform: "translate(3672.521 1547)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-94",
    "data-name": "Shape",
    className: "cls-4",
    d: "M56.16,48.354a7.806,7.806,0,1,1-7.806,7.806A7.806,7.806,0,0,1,56.16,48.354Z",
    transform: "translate(3629.392 1503.871)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-95",
    "data-name": "Shape",
    className: "cls-7",
    d: "M87.319,83.145a4.174,4.174,0,1,1-4.174,4.174A4.174,4.174,0,0,1,87.319,83.145Z",
    transform: "translate(3598.361 1472.84)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-96",
    "data-name": "Shape",
    className: "cls-5",
    d: "M110.088,94.349v15.739H94.349A15.739,15.739,0,0,1,110.088,94.349Z",
    transform: "translate(3588.367 1462.847)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-97",
    "data-name": "Shape",
    className: "cls-8",
    d: "M6.372,0A6.372,6.372,0,1,1,0,6.372,6.372,6.372,0,0,1,6.372,0Z",
    transform: "translate(3711.2 1559.744) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-98",
    "data-name": "Shape",
    className: "cls-5",
    d: "M6.372,0A6.372,6.372,0,1,1,0,6.372,6.372,6.372,0,0,1,6.372,0Z",
    transform: "translate(3711.2 1572.935) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-99",
    "data-name": "Shape",
    className: "cls-5",
    d: "M6.372,0A6.372,6.372,0,1,1,0,6.372,6.372,6.372,0,0,1,6.372,0Z",
    transform: "translate(3724.135 1559.744) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-100",
    "data-name": "Shape",
    className: "cls-6",
    d: "M0,0H6.532A6.532,6.532,0,1,1,0,6.532Z",
    transform: "translate(3724.39 1572.935) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shape-101",
    "data-name": "Shape",
    transform: "translate(3772.416 1565.246) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_612",
    "data-name": "Rectangle 612",
    className: "cls-4",
    width: 8.08,
    height: 8.08,
    transform: "translate(10.426 10.165)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_613",
    "data-name": "Rectangle 613",
    className: "cls-4",
    width: 8.08,
    height: 8.08,
    transform: "translate(10.426)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_614",
    "data-name": "Rectangle 614",
    className: "cls-4",
    width: 8.08,
    height: 8.08,
    transform: "translate(0 10.165)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_615",
    "data-name": "Rectangle 615",
    className: "cls-4",
    width: 8.08,
    height: 8.08
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_616",
    "data-name": "Rectangle 616",
    className: "cls-7",
    width: 3.779,
    height: 3.779,
    transform: "translate(12.642 12.381)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_617",
    "data-name": "Rectangle 617",
    className: "cls-7",
    width: 3.779,
    height: 3.779,
    transform: "translate(12.642 2.216)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_618",
    "data-name": "Rectangle 618",
    className: "cls-7",
    width: 3.779,
    height: 3.779,
    transform: "translate(2.216 12.381)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_619",
    "data-name": "Rectangle 619",
    className: "cls-7",
    width: 3.779,
    height: 3.779,
    transform: "translate(2.216 2.216)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_53",
    "data-name": "Group 53",
    transform: "translate(-4109.501 -11)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Shape-102",
    "data-name": "Shape",
    className: "cls-4",
    cx: 10.924,
    cy: 10.919,
    rx: 10.924,
    ry: 10.919,
    transform: "translate(4060.248 1549.049)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-103",
    "data-name": "Shape",
    className: "cls-5",
    d: "M133.789,0a12.92,12.92,0,0,1-12.9,12.936A12.92,12.92,0,0,1,133.789,0Z",
    transform: "translate(3950.351 1547)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-104",
    "data-name": "Shape",
    className: "cls-6",
    d: "M12.559,0h.377V.376A12.544,12.544,0,0,1,.377,12.9H0v-.376A12.544,12.544,0,0,1,12.559,0Z",
    transform: "translate(4071.044 1547) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-105",
    "data-name": "Shape",
    className: "cls-5",
    d: "M12.528,120.591H12.9v.377A12.544,12.544,0,0,1,.376,133.527H0v-.377A12.544,12.544,0,0,1,12.528,120.591Z",
    transform: "translate(4058.14 1439.473)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-106",
    "data-name": "Shape",
    className: "cls-6",
    d: "M12.559,0h.377V.376A12.544,12.544,0,0,1,.377,12.9H0v-.376A12.544,12.544,0,0,1,12.559,0Z",
    transform: "translate(4084.14 1560.064) rotate(90)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Shape-107",
    "data-name": "Shape",
    className: "cls-4",
    cx: 10.924,
    cy: 10.924,
    r: 10.924,
    transform: "translate(4138.22 1549.015)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-108",
    "data-name": "Shape",
    className: "cls-5",
    d: "M12.621,133A12.621,12.621,0,0,1,0,120.379V120H.379A12.621,12.621,0,0,1,13,132.621V133Z",
    transform: "translate(4136.14 1440)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-109",
    "data-name": "Shape",
    className: "cls-6",
    d: "M132.621,120H133v.379A12.621,12.621,0,0,1,120.379,133H120v-.379A12.621,12.621,0,0,1,132.621,120Z",
    transform: "translate(4029.14 1440)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-110",
    "data-name": "Shape",
    className: "cls-5",
    d: "M120.379,13H120v-.379A12.621,12.621,0,0,1,132.621,0H133V.379A12.621,12.621,0,0,1,120.379,13Z",
    transform: "translate(4029.14 1547)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-111",
    "data-name": "Shape",
    className: "cls-6",
    d: "M.379,0A12.621,12.621,0,0,1,13,12.621V13h-.379A12.621,12.621,0,0,1,0,.379V0Z",
    transform: "translate(4136.14 1547)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-112",
    "data-name": "Shape",
    className: "cls-5",
    d: "M26,0V26H0A26,26,0,0,1,26,0Z",
    transform: "translate(4214.14 1547) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-113",
    "data-name": "Shape",
    className: "cls-4",
    d: "M14.793,0V14.757H0A14.775,14.775,0,0,1,14.793,0Z",
    transform: "translate(4202.896 1558.207) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-114",
    "data-name": "Shape",
    className: "cls-7",
    d: "M6.788,0V6.771H0A6.78,6.78,0,0,1,6.788,0Z",
    transform: "translate(4194.911 1566.212) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-115",
    "data-name": "Shape",
    className: "cls-6",
    d: "M26,0V26H0A26,26,0,0,1,26,0Z",
    transform: "translate(4058.14 1573) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-116",
    "data-name": "Shape",
    className: "cls-4",
    d: "M14.757,0V14.793H0A14.775,14.775,0,0,1,14.757,0Z",
    transform: "translate(4046.897 1561.793) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-117",
    "data-name": "Shape",
    className: "cls-7",
    d: "M6.771,0V6.788H0A6.78,6.78,0,0,1,6.771,0Z",
    transform: "translate(4038.912 1553.788) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-118",
    "data-name": "Shape",
    className: "cls-6",
    d: "M26,0V26H0A26,26,0,0,1,26,0Z",
    transform: "translate(4162.14 1547)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-119",
    "data-name": "Shape",
    className: "cls-4",
    d: "M118.541,103.448v14.793H103.784A14.775,14.775,0,0,1,118.541,103.448Z",
    transform: "translate(4069.599 1454.759)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-120",
    "data-name": "Shape",
    className: "cls-7",
    d: "M184.265,177.34v6.788h-6.771A6.78,6.78,0,0,1,184.265,177.34Z",
    transform: "translate(4003.874 1388.872)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shape-121",
    "data-name": "Shape",
    transform: "translate(4106.522 1569.242) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_107-2",
    "data-name": "Path 107",
    className: "cls-7",
    d: "M0,0,13.047,0l0,13.047L0,13.047Z",
    transform: "translate(9.229 0) rotate(45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108-2",
    "data-name": "Path 108",
    className: "cls-6",
    d: "M0,0H6.567V6.572H0Z",
    transform: "translate(5.945 5.943)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape-122",
    "data-name": "Shape",
    transform: "translate(4136.14 1573) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119-2",
    "data-name": "Path 119",
    className: "cls-4",
    d: "M13,0a13,13,0,0,1,0,26H0V13A13,13,0,0,1,13,0Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120-2",
    "data-name": "Path 120",
    className: "cls-5",
    d: "M7.774,0a7.774,7.774,0,1,1,0,15.548H0V7.774A7.774,7.774,0,0,1,7.774,0Z",
    transform: "translate(0 10.452)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121-2",
    "data-name": "Path 121",
    className: "cls-6",
    d: "M7.937,0A7.937,7.937,0,1,1,0,7.937,7.937,7.937,0,0,1,7.937,0Z",
    transform: "translate(5.063 4.932)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122-2",
    "data-name": "Path 122",
    className: "cls-7",
    d: "M4.646,0A4.646,4.646,0,1,1,0,4.646,4.646,4.646,0,0,1,4.646,0Z",
    transform: "translate(8.354 8.223)"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Shape-123",
    "data-name": "Shape",
    className: "cls-5",
    cx: 13,
    cy: 13,
    r: 13,
    transform: "translate(3876.205 1547)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Shape-124",
    "data-name": "Shape",
    className: "cls-7",
    cx: 7.632,
    cy: 7.632,
    r: 7.632,
    transform: "translate(3881.638 1552.433)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Shape-125",
    "data-name": "Shape",
    className: "cls-6",
    cx: 4.01,
    cy: 4.01,
    r: 4.01,
    transform: "translate(3885.26 1556.055)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Shape-126",
    "data-name": "Shape",
    className: "cls-8",
    cx: 13,
    cy: 13,
    r: 13,
    transform: "translate(3928.14 1547)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Shape-127",
    "data-name": "Shape",
    className: "cls-7",
    cx: 7.632,
    cy: 7.632,
    r: 7.632,
    transform: "translate(3933.573 1552.433)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Shape-128",
    "data-name": "Shape",
    className: "cls-4",
    cx: 4.01,
    cy: 4.01,
    r: 4.01,
    transform: "translate(3937.195 1556.055)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-129",
    "data-name": "Shape",
    className: "cls-5",
    d: "M6.388,12.776A6.388,6.388,0,1,0,0,6.388,6.388,6.388,0,0,0,6.388,12.776Z",
    transform: "translate(3980.108 1560.192) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-130",
    "data-name": "Shape",
    className: "cls-8",
    d: "M6.388,12.776A6.388,6.388,0,1,0,0,6.388,6.388,6.388,0,0,0,6.388,12.776Z",
    transform: "translate(3966.948 1560.192) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-131",
    "data-name": "Shape",
    className: "cls-8",
    d: "M6.388,12.776A6.388,6.388,0,1,0,0,6.388,6.388,6.388,0,0,0,6.388,12.776Z",
    transform: "translate(3980.108 1547.287) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-132",
    "data-name": "Shape",
    className: "cls-6",
    d: "M0,13.1H6.516A6.548,6.548,0,1,0,0,6.548Z",
    transform: "translate(3967.236 1547) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Shape-133",
    "data-name": "Shape",
    className: "cls-4",
    width: 13.287,
    height: 13.287,
    transform: "translate(3999.816 1566.676) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-134",
    "data-name": "Shape",
    className: "cls-6",
    d: "M0,8.1H8.1V0H0Z",
    transform: "translate(3998.803 1560.065) rotate(135)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-135",
    "data-name": "Shape",
    className: "cls-5",
    d: "M0,7.857H7.857A7.857,7.857,0,0,0,0,0Z",
    transform: "translate(4003.649 1557.349) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-136",
    "data-name": "Shape",
    className: "cls-5",
    d: "M0,0V7.857A7.857,7.857,0,0,0,7.857,0Z",
    transform: "translate(4003.649 1570.509) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-137",
    "data-name": "Shape",
    className: "cls-5",
    d: "M7.857,0H0A7.857,7.857,0,0,0,7.857,7.857Z",
    transform: "translate(3990.681 1570.509) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-138",
    "data-name": "Shape",
    className: "cls-5",
    d: "M7.857,7.857V0A7.857,7.857,0,0,0,0,7.857Z",
    transform: "translate(3990.681 1557.349) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shape-139",
    "data-name": "Shape",
    transform: "translate(3872.458 1569.243) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_105-2",
    "data-name": "Path 105",
    className: "cls-8",
    d: "M0,0,13.047,0l0,13.047L0,13.047Z",
    transform: "translate(9.229 0) rotate(45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106-2",
    "data-name": "Path 106",
    className: "cls-4",
    d: "M0,0,6.569,0l0,6.569L0,6.569Z",
    transform: "translate(9.229 4.582) rotate(45)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Shape-140",
    "data-name": "Shape",
    className: "cls-4",
    cx: 10.924,
    cy: 10.919,
    rx: 10.924,
    ry: 10.919,
    transform: "translate(4008.248 1549.049)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-141",
    "data-name": "Shape",
    className: "cls-5",
    d: "M133.789,0a12.92,12.92,0,0,1-12.9,12.936A12.92,12.92,0,0,1,133.789,0Z",
    transform: "translate(3898.351 1547)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-142",
    "data-name": "Shape",
    className: "cls-6",
    d: "M12.559,0h.377V.376A12.544,12.544,0,0,1,.377,12.9H0v-.376A12.544,12.544,0,0,1,12.559,0Z",
    transform: "translate(4019.044 1547) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-143",
    "data-name": "Shape",
    className: "cls-5",
    d: "M12.528,120.591H12.9v.377A12.544,12.544,0,0,1,.376,133.527H0v-.377A12.544,12.544,0,0,1,12.528,120.591Z",
    transform: "translate(4006.14 1439.473)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-144",
    "data-name": "Shape",
    className: "cls-6",
    d: "M12.559,0h.377V.376A12.544,12.544,0,0,1,.377,12.9H0v-.376A12.544,12.544,0,0,1,12.559,0Z",
    transform: "translate(4032.14 1560.064) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-145",
    "data-name": "Shape",
    className: "cls-8",
    d: "M59.4,0H72.53L65.965,6.565Z",
    transform: "translate(3849.175 1547)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-146",
    "data-name": "Shape",
    className: "cls-6",
    d: "M26,0V26H0Z",
    transform: "translate(3902.14 1547)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-147",
    "data-name": "Shape",
    className: "cls-4",
    d: "M0,0,26,26H0Z",
    transform: "translate(3902.14 1547)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Shape-148",
    "data-name": "Shape",
    className: "cls-8",
    cx: 13,
    cy: 13,
    r: 13,
    transform: "translate(4344.14 1547)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Shape-149",
    "data-name": "Shape",
    className: "cls-7",
    cx: 7.632,
    cy: 7.632,
    r: 7.632,
    transform: "translate(4349.573 1552.303)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Shape-150",
    "data-name": "Shape",
    className: "cls-4",
    cx: 4.01,
    cy: 4.01,
    r: 4.01,
    transform: "translate(4353.195 1555.925)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shape-151",
    "data-name": "Shape",
    transform: "translate(4396.14 1573) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_101-2",
    "data-name": "Path 101",
    className: "cls-4",
    d: "M13,26A13,13,0,0,0,13,0H0V13A13,13,0,0,0,13,26Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102-2",
    "data-name": "Path 102",
    className: "cls-5",
    d: "M7.774,15.548A7.774,7.774,0,1,0,7.774,0H0V7.774A7.774,7.774,0,0,0,7.774,15.548Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103-2",
    "data-name": "Path 103",
    className: "cls-6",
    d: "M7.937,15.874A7.937,7.937,0,1,0,0,7.937,7.937,7.937,0,0,0,7.937,15.874Z",
    transform: "translate(5.063 5.194)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104-2",
    "data-name": "Path 104",
    className: "cls-7",
    d: "M4.646,9.293A4.646,4.646,0,1,0,0,4.646,4.646,4.646,0,0,0,4.646,9.293Z",
    transform: "translate(8.354 8.484)"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Shape-152",
    "data-name": "Shape",
    className: "cls-4",
    cx: 10.924,
    cy: 10.924,
    r: 10.924,
    transform: "translate(4238.125 1549.08) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-153",
    "data-name": "Shape",
    className: "cls-5",
    d: "M12.621,13A12.621,12.621,0,0,1,0,.379V0H.379A12.621,12.621,0,0,1,13,12.621V13Z",
    transform: "translate(4227.14 1547) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-154",
    "data-name": "Shape",
    className: "cls-6",
    d: "M12.621,0H13V.379A12.621,12.621,0,0,1,.379,13H0v-.379A12.621,12.621,0,0,1,12.621,0Z",
    transform: "translate(4227.14 1560) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-155",
    "data-name": "Shape",
    className: "cls-5",
    d: "M.379,13H0v-.379A12.621,12.621,0,0,1,12.621,0H13V.379A12.621,12.621,0,0,1,.379,13Z",
    transform: "translate(4240.14 1560) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-156",
    "data-name": "Shape",
    className: "cls-6",
    d: "M.379,0A12.621,12.621,0,0,1,13,12.621V13h-.379A12.621,12.621,0,0,1,0,.379V0Z",
    transform: "translate(4240.14 1547) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-157",
    "data-name": "Shape",
    className: "cls-5",
    d: "M6.388,0A6.388,6.388,0,1,1,0,6.388,6.388,6.388,0,0,1,6.388,0Z",
    transform: "translate(4279.332 1559.808) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-158",
    "data-name": "Shape",
    className: "cls-8",
    d: "M6.388,0A6.388,6.388,0,1,1,0,6.388,6.388,6.388,0,0,1,6.388,0Z",
    transform: "translate(4266.172 1559.808) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-159",
    "data-name": "Shape",
    className: "cls-8",
    d: "M6.388,0A6.388,6.388,0,1,1,0,6.388,6.388,6.388,0,0,1,6.388,0Z",
    transform: "translate(4279.332 1572.713) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-160",
    "data-name": "Shape",
    className: "cls-6",
    d: "M0,0H6.516A6.548,6.548,0,1,1,0,6.548Z",
    transform: "translate(4266.14 1573) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Shape-161",
    "data-name": "Shape",
    className: "cls-4",
    width: 13.288,
    height: 13.288,
    transform: "translate(4311.815 1566.612) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-162",
    "data-name": "Shape",
    className: "cls-6",
    d: "M0,0H8.1V8.1H0Z",
    transform: "translate(4305.075 1565.662) rotate(-135)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-163",
    "data-name": "Shape",
    className: "cls-5",
    d: "M0,0H7.857A7.858,7.858,0,0,1,0,7.857Z",
    transform: "translate(4315.648 1570.509) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-164",
    "data-name": "Shape",
    className: "cls-5",
    d: "M0,7.857V0A7.857,7.857,0,0,1,7.857,7.857Z",
    transform: "translate(4315.648 1557.349) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-165",
    "data-name": "Shape",
    className: "cls-5",
    d: "M7.857,7.857H0A7.857,7.857,0,0,1,7.857,0Z",
    transform: "translate(4302.68 1557.349) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-166",
    "data-name": "Shape",
    className: "cls-5",
    d: "M7.857,0V7.857A7.857,7.857,0,0,1,0,0Z",
    transform: "translate(4302.68 1570.509) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shape-167",
    "data-name": "Shape",
    transform: "translate(4240.14 1547)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_113-2",
    "data-name": "Path 113",
    className: "cls-6",
    d: "M13,0H26V13A13,13,0,0,1,13,26H0V13A13,13,0,0,1,13,0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114-2",
    "data-name": "Path 114",
    className: "cls-7",
    d: "M57.09,51.859a7.643,7.643,0,1,1,0,15.286H49.447V59.5A7.643,7.643,0,0,1,57.09,51.859Z",
    transform: "translate(-44.09 -46.241)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115-2",
    "data-name": "Path 115",
    className: "cls-4",
    d: "M128.4,0h5.2V5.2a7.8,7.8,0,0,1-7.8,7.8h-5.2V7.8A7.8,7.8,0,0,1,128.4,0Z",
    transform: "translate(-107.538)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Shape-168",
    "data-name": "Shape",
    className: "cls-8",
    d: "M0,0H13.13L6.565,6.565Z",
    transform: "translate(4337.77 1573) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-169",
    "data-name": "Shape",
    className: "cls-6",
    d: "M26,0V26H0Z",
    transform: "translate(4344.205 1573) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-170",
    "data-name": "Shape",
    className: "cls-4",
    d: "M0,0,26,26H0Z",
    transform: "translate(4344.205 1573) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shape-171",
    "data-name": "Shape",
    transform: "translate(4574.011 1569.225) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89-2",
    "data-name": "Path 89",
    className: "cls-7",
    d: "M0,13.019l13.014,0L13.019,0,0,0Z",
    transform: "translate(0 9.206) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90-2",
    "data-name": "Path 90",
    className: "cls-6",
    d: "M0,6.555H6.551V0H0Z",
    transform: "translate(5.93 5.928)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Shape-172",
    "data-name": "Shape",
    className: "cls-6",
    d: "M12.967,0A12.967,12.967,0,1,1,0,12.967,12.967,12.967,0,0,1,12.967,0Z",
    transform: "translate(4525.814 1547.065)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-173",
    "data-name": "Shape",
    className: "cls-4",
    d: "M56.16,48.354a7.806,7.806,0,1,1-7.806,7.806A7.806,7.806,0,0,1,56.16,48.354Z",
    transform: "translate(4482.686 1503.937)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-174",
    "data-name": "Shape",
    className: "cls-7",
    d: "M87.319,83.145a4.174,4.174,0,1,1-4.174,4.174A4.174,4.174,0,0,1,87.319,83.145Z",
    transform: "translate(4451.654 1472.905)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-175",
    "data-name": "Shape",
    className: "cls-5",
    d: "M110.088,94.349v15.739H94.349A15.739,15.739,0,0,1,110.088,94.349Z",
    transform: "translate(4441.661 1462.912)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-176",
    "data-name": "Shape",
    className: "cls-5",
    d: "M6.372,0A6.372,6.372,0,1,1,0,6.372,6.372,6.372,0,0,1,6.372,0Z",
    transform: "translate(4408.885 1559.81) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-177",
    "data-name": "Shape",
    className: "cls-8",
    d: "M6.372,0A6.372,6.372,0,1,1,0,6.372,6.372,6.372,0,0,1,6.372,0Z",
    transform: "translate(4408.885 1573) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-178",
    "data-name": "Shape",
    className: "cls-8",
    d: "M6.372,0A6.372,6.372,0,1,1,0,6.372,6.372,6.372,0,0,1,6.372,0Z",
    transform: "translate(4421.82 1559.81) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-179",
    "data-name": "Shape",
    className: "cls-6",
    d: "M0,0H6.532A6.532,6.532,0,1,1,0,6.532Z",
    transform: "translate(4422.075 1573) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shape-180",
    "data-name": "Shape",
    transform: "translate(4448.01 1547.065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_109-2",
    "data-name": "Path 109",
    className: "cls-4",
    d: "M12.967,0a12.967,12.967,0,1,1,0,25.935H0V12.967A12.967,12.967,0,0,1,12.967,0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110-2",
    "data-name": "Path 110",
    className: "cls-7",
    d: "M7.754,96.482a7.754,7.754,0,1,1,0,15.509H0v-7.754A7.754,7.754,0,0,1,7.754,96.482Z",
    transform: "translate(0 -86.056)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111-2",
    "data-name": "Path 111",
    className: "cls-6",
    d: "M54.651,45.528a7.917,7.917,0,1,1-7.917,7.917A7.917,7.917,0,0,1,54.651,45.528Z",
    transform: "translate(-41.684 -40.608)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112-2",
    "data-name": "Path 112",
    className: "cls-7",
    d: "M81.745,75.9a4.635,4.635,0,1,1-4.635,4.635A4.635,4.635,0,0,1,81.745,75.9Z",
    transform: "translate(-68.778 -67.702)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape-181",
    "data-name": "Shape",
    transform: "translate(4473.944 1573) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_116-2",
    "data-name": "Path 116",
    className: "cls-6",
    d: "M13.033,0h12.9V12.9A13.033,13.033,0,0,1,12.9,25.935H0v-12.9A13.033,13.033,0,0,1,13.033,0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117-2",
    "data-name": "Path 117",
    className: "cls-7",
    d: "M7.624,0a7.624,7.624,0,1,1,0,15.248H0V7.624A7.624,7.624,0,0,1,7.624,0Z",
    transform: "translate(5.343 5.604)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118-2",
    "data-name": "Path 118",
    className: "cls-8",
    d: "M7.78,0h5.187V5.187a7.78,7.78,0,0,1-7.78,7.78H0V7.78A7.78,7.78,0,0,1,7.78,0Z",
    transform: "translate(13.033)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Shape-182",
    "data-name": "Shape",
    className: "cls-6",
    d: "M72.5,185.949H59.4l6.549-6.549Z",
    transform: "translate(4369.094 1387.052)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-183",
    "data-name": "Shape",
    className: "cls-4",
    d: "M0,25.935V0H25.935Z",
    transform: "translate(4422.075 1547.065)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-184",
    "data-name": "Shape",
    className: "cls-5",
    d: "M25.935,25.935,0,0H25.935Z",
    transform: "translate(4422.075 1547.065)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-185",
    "data-name": "Shape",
    className: "cls-8",
    d: "M59.4,0H72.5L65.949,6.549Z",
    transform: "translate(4446.963 1547.065)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-186",
    "data-name": "Shape",
    className: "cls-6",
    d: "M25.935,0V25.935H0Z",
    transform: "translate(4499.944 1547.065)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-187",
    "data-name": "Shape",
    className: "cls-4",
    d: "M0,0,25.935,25.935H0Z",
    transform: "translate(4499.944 1547.065)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shape-188",
    "data-name": "Shape",
    transform: "translate(3776.195 1547)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91-2",
    "data-name": "Path 91",
    className: "cls-4",
    d: "M12.967-214.065a12.967,12.967,0,0,0,12.967-12.967A12.967,12.967,0,0,0,12.967-240H0v12.967A12.967,12.967,0,0,0,12.967-214.065Z",
    transform: "translate(0 240)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92-2",
    "data-name": "Path 92",
    className: "cls-7",
    d: "M7.754-224.491a7.754,7.754,0,0,0,7.754-7.754A7.754,7.754,0,0,0,7.754-240H0v7.754A7.754,7.754,0,0,0,7.754-224.491Z",
    transform: "translate(0 240)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93-2",
    "data-name": "Path 93",
    className: "cls-6",
    d: "M54.651-176.225a7.917,7.917,0,0,0,7.917-7.917,7.917,7.917,0,0,0-7.917-7.917,7.917,7.917,0,0,0-7.917,7.917A7.917,7.917,0,0,0,54.651-176.225Z",
    transform: "translate(-41.684 197.24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94-2",
    "data-name": "Path 94",
    className: "cls-7",
    d: "M81.745-152.414a4.635,4.635,0,0,0,4.635-4.635,4.635,4.635,0,0,0-4.635-4.635,4.635,4.635,0,0,0-4.635,4.635A4.635,4.635,0,0,0,81.745-152.414Z",
    transform: "translate(-68.778 170.146)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape-189",
    "data-name": "Shape",
    transform: "translate(3828.065 1547) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95-2",
    "data-name": "Path 95",
    className: "cls-6",
    d: "M13.033,25.935h12.9v-12.9A13.033,13.033,0,0,0,12.9,0H0V12.9A13.033,13.033,0,0,0,13.033,25.935Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96-2",
    "data-name": "Path 96",
    className: "cls-7",
    d: "M7.624,15.248A7.624,7.624,0,1,0,7.624,0H0V7.624A7.624,7.624,0,0,0,7.624,15.248Z",
    transform: "translate(5.343 5.083)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97-2",
    "data-name": "Path 97",
    className: "cls-8",
    d: "M7.78,12.967h5.187V7.78A7.78,7.78,0,0,0,5.187,0H0V5.187A7.78,7.78,0,0,0,7.78,12.967Z",
    transform: "translate(13.033 12.967)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape-190",
    "data-name": "Shape",
    transform: "translate(3854 1547) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_98-2",
    "data-name": "Path 98",
    className: "cls-5",
    d: "M13.033,0h12.9V12.9A13.033,13.033,0,0,1,12.9,25.935H0v-12.9A13.033,13.033,0,0,1,13.033,0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99-2",
    "data-name": "Path 99",
    className: "cls-7",
    d: "M7.624,0a7.624,7.624,0,1,1,0,15.248H0V7.624A7.624,7.624,0,0,1,7.624,0Z",
    transform: "translate(5.343 5.604)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100-2",
    "data-name": "Path 100",
    className: "cls-8",
    d: "M7.78,0h5.187V5.187a7.78,7.78,0,0,1-7.78,7.78H0V7.78A7.78,7.78,0,0,1,7.78,0Z",
    transform: "translate(13.033)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Shape-191",
    "data-name": "Shape",
    className: "cls-5",
    d: "M25.935,0V25.935H0A25.935,25.935,0,0,1,25.935,0Z",
    transform: "translate(3724.326 1547)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-192",
    "data-name": "Shape",
    className: "cls-4",
    d: "M118.2,103.784V118.5H103.448A14.738,14.738,0,0,1,118.2,103.784Z",
    transform: "translate(3632.056 1454.431)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-193",
    "data-name": "Shape",
    className: "cls-7",
    d: "M184.111,177.494v6.755H177.34A6.763,6.763,0,0,1,184.111,177.494Z",
    transform: "translate(3566.149 1388.686)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-194",
    "data-name": "Shape",
    className: "cls-6",
    d: "M12.967,0A12.967,12.967,0,1,1,0,12.967,12.967,12.967,0,0,1,12.967,0Z",
    transform: "translate(3672.521 1547)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-195",
    "data-name": "Shape",
    className: "cls-4",
    d: "M56.16,48.354a7.806,7.806,0,1,1-7.806,7.806A7.806,7.806,0,0,1,56.16,48.354Z",
    transform: "translate(3629.392 1503.871)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-196",
    "data-name": "Shape",
    className: "cls-7",
    d: "M87.319,83.145a4.174,4.174,0,1,1-4.174,4.174A4.174,4.174,0,0,1,87.319,83.145Z",
    transform: "translate(3598.361 1472.84)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-197",
    "data-name": "Shape",
    className: "cls-5",
    d: "M110.088,94.349v15.739H94.349A15.739,15.739,0,0,1,110.088,94.349Z",
    transform: "translate(3588.367 1462.847)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-198",
    "data-name": "Shape",
    className: "cls-8",
    d: "M6.372,0A6.372,6.372,0,1,1,0,6.372,6.372,6.372,0,0,1,6.372,0Z",
    transform: "translate(3711.2 1559.744) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-199",
    "data-name": "Shape",
    className: "cls-5",
    d: "M6.372,0A6.372,6.372,0,1,1,0,6.372,6.372,6.372,0,0,1,6.372,0Z",
    transform: "translate(3711.2 1572.935) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-200",
    "data-name": "Shape",
    className: "cls-5",
    d: "M6.372,0A6.372,6.372,0,1,1,0,6.372,6.372,6.372,0,0,1,6.372,0Z",
    transform: "translate(3724.135 1559.744) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-201",
    "data-name": "Shape",
    className: "cls-6",
    d: "M0,0H6.532A6.532,6.532,0,1,1,0,6.532Z",
    transform: "translate(3724.39 1572.935) rotate(180)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shape-202",
    "data-name": "Shape",
    transform: "translate(3772.416 1565.246) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_612-2",
    "data-name": "Rectangle 612",
    className: "cls-4",
    width: 8.08,
    height: 8.08,
    transform: "translate(10.426 10.165)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_613-2",
    "data-name": "Rectangle 613",
    className: "cls-4",
    width: 8.08,
    height: 8.08,
    transform: "translate(10.426)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_614-2",
    "data-name": "Rectangle 614",
    className: "cls-4",
    width: 8.08,
    height: 8.08,
    transform: "translate(0 10.165)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_615-2",
    "data-name": "Rectangle 615",
    className: "cls-4",
    width: 8.08,
    height: 8.08
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_616-2",
    "data-name": "Rectangle 616",
    className: "cls-7",
    width: 3.779,
    height: 3.779,
    transform: "translate(12.642 12.381)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_617-2",
    "data-name": "Rectangle 617",
    className: "cls-7",
    width: 3.779,
    height: 3.779,
    transform: "translate(12.642 2.216)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_618-2",
    "data-name": "Rectangle 618",
    className: "cls-7",
    width: 3.779,
    height: 3.779,
    transform: "translate(2.216 12.381)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_619-2",
    "data-name": "Rectangle 619",
    className: "cls-7",
    width: 3.779,
    height: 3.779,
    transform: "translate(2.216 2.216)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopDivider1);
export default __webpack_public_path__ + "static/media/Desktop-Divider-1.cada67579d1cba04fe2b41ebf5a129ec.svg";
export { ForwardRef as ReactComponent };